import * as React from 'react';
import MUIDataTable from "mui-datatables";
import { useCallback, useEffect, } from "react";
import { useStore } from "../../redux/Store";
import { UserSearchHeader } from "../Headers";
import action from '../Action';
import Button from "@material-ui/core/Button";
import UserDetails from './UserDetails';
import { makeStyles } from '@material-ui/core/styles';
import { getResults } from "../../apis/configs/axiosUtils";
import { toast } from 'react-hot-toast';
import LinearProgress from '@material-ui/core/LinearProgress';
import { validateTokenExpiration } from "../../apis/configs/axiosUtils"

const useStyles = makeStyles(theme => ({
  modal: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    overflow:'scroll',
    height:'auto',
    backgroundColor: '#1A2C80',
    background: '#1A2C80'
    }, 
  paper: {
    padding: theme.spacing(2, 4, 3),
    },
  elementContainer: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-start',
    paddingBottom: '10px'
    }, 
  buttonContainer: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-start',
    }, 
  bottomNavContainer: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-start',
    paddingBottom: '10px'
    }, 
  headerContainer: {
    display: 'flex',
    flexDirection: 'row',
    height: '55px',
    justifyContent: 'space-between',
    padding: '10px',
    alignItems: 'center',
    backgroundColor: '#fff',
    background: '#e5e3e3',
    boxShadow: theme.shadows[5],
    borderRadius: '5px',
    fontStyle: 'italic',
    },
  navContainer: {
    display: 'flex',
    flexDirection: 'row',
    height: '55px',
    justifyContent: 'space-between',
    padding: '10px',
    paddingBottom: '0px',
    backgroundColor: '#fff',
    background: '#e5e3e3',
    boxShadow: theme.shadows[5],
    borderRadius: '5px',
    },
  })
);

const UserSearchResults = () => {
  const store = useStore();
  const [loading, setLoading] = React.useState(false);
  const timerRef = React.useRef<number>();

  React.useEffect(
    () => () => {
      clearTimeout(timerRef.current);
    },
    [],
  );

  const handleLoading = () => {
    setLoading((prevLoading) => !prevLoading);
  };

  // const delay = (ms: number) => new Promise(
  //   resolve => setTimeout(resolve, ms)
  // );

  const searchResults = store.state.userSearchResults;

  let searchTerms = {
    "FIRST_NAME": store.state?.searchTerms?.first_name,
    "LAST_NAME": store.state?.searchTerms?.last_name,
    "EMP_NUM": store.state?.searchTerms?.emp_no,
    "RT_BASE_MONTH": store.state?.searchTerms?.rt_month,
    "include_on_leave": store.state?.searchTerms?.include_on_leave,
    "include_terminated": store.state?.searchTerms?.include_terminated
  }

  const updateUserSearchResults = useCallback((results: any) => {
    const { dispatch } = store;
    // @ts-ignore
    dispatch(action("USER_SEARCH_RESULTS", results));
  }, [store]);

  const fetchUserSearchResults = async () => {
    //event.preventDefault();
    handleLoading();
    try {
        const result = await getResults(searchTerms);
        handleLoading();
        updateUserSearchResults(result);
    } catch (error) {
      handleLoading();
      toast.error('Search Request Failed: \n' + error, {
        style: {
          border: '1px solid #D5152E',
          padding: '16px',
          color: '#1A2C80'
          }
        });
    }
  };

  useEffect(() => {
    fetchUserSearchResults();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [store?.state?.selectedUserDetails?.show_details]);

  //Important to keep these options to control on row click.
  const options = {
    width: '500px',
    tableBodyMaxHeight: '500px',
    textLabels: {
      body: {
          noMatch: loading ?
              <LinearProgress /> :
              'Sorry, search query returned no matching results; please try again.',
            },
               },
    onRowClick: (rowData: string[]) => {
      validateTokenExpiration();
      handleClick(rowData);
    },
    selectableRows: 'none' as any,
    
  };

  const handleClick = useCallback((rowData:string[]) => {
    const { dispatch } = store;
    //set user details to rowData and set show_details to true
    const clickedUser = rowData;
    const clickedUserDetails = {
      emp_no: clickedUser[0],
      location: clickedUser[7],
      first_name: clickedUser[1],
      last_name: clickedUser[2],
      job_title: clickedUser[6],
      status: clickedUser[5],
      seniority_no: clickedUser[8],
      rt_month: clickedUser[3],
      exp_date: clickedUser[4],
      show_details: true,
    };

    // @ts-ignore
    dispatch(action("SELECTED_USER_DETAILS", clickedUserDetails));
  }, [store]);

  const goBack = useCallback(() => {
    const { dispatch } = store;
    const searchTerms = {...store.state.searchTerms};
    searchTerms.showResults = false;
    // @ts-ignore
    dispatch(action("SEARCH_TERMS_UPDATED", searchTerms));
  }, [store]);

  const classes = useStyles();

  return (
    <div className={classes.paper}>
      <div className={classes.headerContainer}>
          <h2>Employee Search Results</h2>
          <div className={classes.buttonContainer}>
          <Button onClick={goBack} variant="contained" style={{ color: '#fff', backgroundColor: '#304CB2'}} title='Return to Employee Search dialog'>Back</Button>
        </div>
      </div>
      <br />
          <MUIDataTable
          title={""}
          data={searchResults}
          columns={UserSearchHeader}
          options={options}
        />

      <br />
      {/* <div className={classes.navContainer}>
        <div className={classes.elementContainer}>
          <Button onClick={goBack} variant="contained" style={{ color: '#fff', backgroundColor: '#304CB2'}}>Back</Button>
        </div>
        <div className={classes.elementContainer}>
          <p> </p>
        </div> */}
        <div className={classes.elementContainer}>
          <UserDetails />
        </div>
      {/* </div> */}

    </div>
  )
}

export default UserSearchResults;
